export const EVENT_NAME = {
  START: "Login Start",
  ATTEMPT: "Login Attempt",
  SUCCESS: "Login Success",
  ERROR: "Login Error",
  OPEN: "Open",
  FIELD_COMPLETE: "Field Complete",
  SELECT_STATE: "Select State",
  FORGOT_CREDENTIALS: "Forgot Password Clicked"
};
